const IMAGE_EXTENSIONS = ["webp", "jpg", "png"];
const DEFAULT_IMAGE_BASE_URL =
  process.env.REACT_APP_CARD_IMAGE_BASE_URL || "/card-images";
const CARD_TYPE_LABELS = {
  1: "UNIT",
  2: "CHARACTER",
  3: "COMMAND",
  4: "OPERATION",
  10: "GENERATION",
  11: "ACE",
};

function sanitizeStem(value) {
  return String(value || "")
    .trim()
    .replace(/[\\/:*?"<>|]+/g, "_")
    .replace(/\s+/g, "_");
}

export function getCardCode(card) {
  const left = card?.cardNumber1 ? String(card.cardNumber1).trim() : "";
  const right = card?.cardNumber2 ? String(card.cardNumber2).trim() : "";
  return [left, right].filter(Boolean).join("-");
}

export function isBasicGCard(card) {
  const left = card?.cardNumber1 ? String(card.cardNumber1).trim().toUpperCase() : "";
  return left === "G";
}

export function getCardTypeLabel(card) {
  if (isBasicGCard(card)) {
    return "基本G";
  }

  const typeName = card?.card_type_name ? String(card.card_type_name).trim() : "";
  if (typeName) return typeName;

  const numericCardType = Number(card?.cardType ?? card?.card_type ?? "");
  if (Number.isFinite(numericCardType) && CARD_TYPE_LABELS[numericCardType]) {
    return CARD_TYPE_LABELS[numericCardType];
  }

  return "その他";
}

export function getCardImageCandidates(card) {
  const directCandidates = Array.isArray(card?.imageCandidates)
    ? card.imageCandidates
        .map((value) => String(value || "").trim())
        .filter(Boolean)
    : [];
  const directImagePath = card?.imagePath ? String(card.imagePath).trim() : "";
  const stems = [];
  const cardId = card?.cardId != null ? String(card.cardId).trim() : "";
  const cardCode = sanitizeStem(getCardCode(card));

  if (directImagePath) {
    directCandidates.unshift(directImagePath);
  }
  if (cardId) {
    stems.push(cardId);
  }
  if (cardCode) {
    stems.push(cardCode);
  }

  return [
    ...Array.from(new Set(directCandidates)),
    ...Array.from(new Set(stems)).flatMap((stem) =>
      IMAGE_EXTENSIONS.map((ext) => `${DEFAULT_IMAGE_BASE_URL}/${stem}.${ext}`)
    ),
  ];
}

export function getCardPlaceholderLabel(card) {
  const code = getCardCode(card);
  if (code) return code;
  if (card?.cardId != null) return `ID ${card.cardId}`;
  return "Unknown";
}

export const CARD_IMAGE_BASE_URL = DEFAULT_IMAGE_BASE_URL;
